






















import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import gsap from 'gsap';

@Component
export default class Button extends Vue {

	@Prop()
	public icon!:string;
	@Prop()
	public iconSelected!:string;
	@Prop()
	public title!:string;
	@Prop()
	public name!:string;
	@Prop({default: false})
	public loading!:boolean;
	@Prop({default: "button"})
	public type!:string;
	@Prop()
	public target!:string;
	@Prop({default: null})
	public to!:any;
	@Prop({default: -1})
	public percent!:number;
	@Prop({default:false})
	public white!:boolean;
	@Prop({default:false})
	public red!:boolean;
	@Prop({default:false})
	public selected!:boolean;
	@Prop({default:false})
	public disabled!:boolean;
	@Prop({default:false})
	public value!:boolean;

	private iconClass:string = "";
	public pInterpolated:number = -1;
	public checked:boolean = false;

	public get nodeType():string {
		if(this.to) return "router-link";
		if(this.type == "checkbox") return "div";
		return "button";
	}

	public get parsedIcon():string {
		if(this.type == "checkbox" && this.value) {
			return require("@/assets/icons/checkmark.svg");
		}
		if(this.selected !== false && this.iconSelected) {
			return this.iconSelected;
		}else{
			return this.icon;
		}
	}

	public get progressStyle():any {
		if(this.pInterpolated> -1 && this.pInterpolated<100) {
			let p:number = Math.round(this.pInterpolated);
			let color = "255, 255, 255";
			let alpha = .5;
			if(this.white) {
				color = "75, 201, 194"
				alpha = .3;
			}
			return {backgroundImage: "linear-gradient(to right, rgba("+color+",0) "+p+"%,rgba("+color+",0) "+p+"%,rgba("+color+","+alpha+") "+p+"%,rgba("+color+","+alpha+") 100%)"};
		}else{
			return {};
		}
	}

	public get classes():any {
		let list =  ["button"]
		if(!this.title) list.push("noTitle");
		if(this.white !== false) list.push("white");
		if(this.red !== false) list.push("red");
		if(this.selected !== false) list.push("selected");
		if(this.loading !== false) list.push("disabled");
		if(this.disabled !== false) list.push("disabled");
		if(this.type == "checkbox") list.push("checkbox");
		return list;
	}

	public mounted():void {
		this.checked = this.value;
	}
	
	public beforeDestroy():void {
		
	}

	public resetBrowse():void {
		(<HTMLFormElement>this.$refs.browse).value = null;
	}


	@Watch("checked")
	public onSelectStateChange():void {
		this.$emit('input', this.checked);
	}

	@Watch("percent")
	private onPercentChange():void {
		let duration = this.percent < this.pInterpolated? 0 : .35;
		gsap.killTweensOf(this);
		gsap.to(this, {duration, pInterpolated:this.percent, ease:"sine.inout"});
	}

}
